<script setup lang="ts">
const paginationContext = usePaginationContext();
const theme = usePaginationTheme();
</script>
<template>
  <button
    v-for="(size, index) in paginationContext.pageSizeOptions.value"
    :key="`${size}-${index}`"
    :class="
      theme.pageSize.button({
        state: size === paginationContext.currentPageSize.value ? 'active' : 'default'
      })
    "
    :disabled="size === paginationContext.currentPageSize.value"
    type="button"
    :aria-label="`${$t('Pagination.Aria.ItemsPerPage', { type: paginationContext.itemTypePlural.value })} ${size}`"
    @click="paginationContext.setPageSize(size)"
  >
    {{ size }}
  </button>
</template>
